import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Partner } from "../models/partner";
import { UserData } from "../models/user-data";

@Injectable()
export abstract class LinkedPartnerUsersServiceBase implements OnDestroy {
  protected destroyed$: Subject<void> = new Subject<void>();

  constructor() {}

  abstract getCatalogEntityPartners$(catalogEntityId: number): Observable<Partner[]>;
  abstract getPartnerUsers$(catalogEntityId: number, partnerId: number): Observable<UserData>;
  abstract postPartnerUsers$(catalogEntityId: number, partnerId: number, selectedUsers: number[]): Observable<boolean>;

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
